import { useMutation } from '@tanstack/react-query';
import { toast } from '@huspy/forge/shared';
import { useTranslation } from 'react-i18next';
import { bankApplicationsApi } from '@modules/opportunities/entities/bankApplication/api';
import { trackAmplitudeEvent } from '@shared/analytics/amplitude';
import { USER_EVENTS } from '@shared/analytics/events';
import { DIGITAL_DOCUMENT } from '../const';

const useGenerateDigitalDocument = (opportunityExternalId: string) => {
  const { t } = useTranslation();

  const {
    mutateAsync,
    isPending,
  } = useMutation({
    mutationKey: ['generateDigitalDocumentFromTemplate'],
    mutationFn: ({ bankApplicationExternalId }:
    { bankApplicationExternalId: string }) => {
      // Track attempt
      trackAmplitudeEvent(USER_EVENTS.CASE.CASE_DIGITAL_BANK_FORM_GENERATION_ATTEMPTED, { useContext: true });

      return bankApplicationsApi.generateDigitalBankApplication(
        { opportunityExternalId, bankApplicationExternalId }
      );
    },
    onSuccess: () => {
      // Track success
      trackAmplitudeEvent(USER_EVENTS.CASE.CASE_DIGITAL_BANK_FORM_GENERATION_COMPLETED, { useContext: true });
      trackAmplitudeEvent(DIGITAL_DOCUMENT.generateDocument);
    },
    onError: (error) => {
      // Track fail
      trackAmplitudeEvent(USER_EVENTS.CASE.CASE_DIGITAL_BANK_FORM_GENERATION_FAILED, {
        useContext: true,
        error_message: error.message ?? error,
      });

      const defaultMessage = t('opportunity.caseSubmission.digitalDocument.notifications.generationFailed');
      toast('error', { message: error.message || defaultMessage });
    },
  });

  return { mutateAsync, isPending };
};

export default useGenerateDigitalDocument;
